import $ from 'jquery';

export default class FAQCat {
    constructor(qaa) {
        this.$qaa = $(qaa);
        this.$q = this.$qaa.find('.fc__q-q');
        this.$a = this.$qaa.find('.fc__q-a');
        if (this.$q.length && this.$a.length) this.init();
    }

    init() {
        this.$q.on('click', () => {
            this.$q.toggleClass('active');
            if (this.$q.hasClass('active')) {
                $('.fc__q-q').removeClass('active');
                $('.fc__q-a').removeAttr('style');
                this.$q.addClass('active');
                this.$a.css('height', this.$a[0].scrollHeight + 'px');
            } else {
                this.$a.removeAttr('style');
            }
        });
    }
}